import * as React from "react";

function SvgFreeTimeCooking(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 568 504"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <g transform="translate(-133.12 -126.397)">
        <g id="free_time_cooking_svg__cooking">
          <g transform="matrix(-1.19807 0 0 -.6439 920.043 825.055)">
            <path
              d="M623.574 632.587h-408l46-274 87.26-55.91h152.825l75.915 55.91 46 274z"
              fill="#fe8d8a"
            />
            <clipPath id="free_time_cooking_svg___clip1">
              <path d="M623.574 632.587h-408l46-274 87.26-55.91h152.825l75.915 55.91 46 274z" />
            </clipPath>
            <g clipPath="url(#free_time_cooking_svg___clip1)">
              <path
                d="M493.046 683.876l66-270 132 7-71 233-127 30z"
                fill="#fd8784"
                transform="matrix(-.83468 0 0 -1.55305 767.938 1309.3)"
              />
              <path
                d="M493.046 683.876l66-270 132 7-71 233-127 30z"
                fill="#fd9794"
                transform="matrix(.83468 0 0 -1.55305 83.427 1307.75)"
              />
              <path
                d="M201.574 348.587c47.275-39.601 357.482-46.215 426-4 16.997 32.804 10.301 80.25-40.371 30.383-8.704 27.896-57.923 28.728-76.629 2.617-13.663 19.771-32.341 21.235-48 0-15.331 24.281-48.336 21.052-73-1-21.004 31.699-78.669 20.311-98-8-12.685 41.246-56.995 32.207-64 2-21.863 34.151-51.137 16.849-26-22z"
                fill="#fe7e7b"
                transform="matrix(-1 0 0 -1.85973 824.906 1249.56)"
              />
            </g>
          </g>
          <g transform="matrix(1.19807 0 0 1.19747 -73.334 -12.06)">
            <path
              d="M201.574 348.587c-42.662-20.925-44.391-82.909 33.522-151.574 108.342-95.482 236.069-106 334.022-12.137 91.498 87.678 86.663 128.531 58.456 159.711 16.997 32.804 10.301 80.25-40.371 30.383-8.704 27.896-57.923 28.728-76.629 2.617-13.663 19.771-32.341 21.235-48 0-15.331 24.281-48.336 21.052-73-1-21.004 31.699-78.669 20.311-98-8-12.685 41.246-56.995 32.207-64 2-21.863 34.151-51.137 16.849-26-22z"
              fill="#feb4b2"
            />
            <clipPath id="free_time_cooking_svg___clip2">
              <path d="M201.574 348.587c-42.662-20.925-44.391-82.909 33.522-151.574 108.342-95.482 236.069-106 334.022-12.137 91.498 87.678 86.663 128.531 58.456 159.711 16.997 32.804 10.301 80.25-40.371 30.383-8.704 27.896-57.923 28.728-76.629 2.617-13.663 19.771-32.341 21.235-48 0-15.331 24.281-48.336 21.052-73-1-21.004 31.699-78.669 20.311-98-8-12.685 41.246-56.995 32.207-64 2-21.863 34.151-51.137 16.849-26-22z" />
            </clipPath>
            <g clipPath="url(#free_time_cooking_svg___clip2)">
              <path
                d="M142.313 489.962s-80.242-198.044 89.488-284.01c-115.438 137.3-15.851 190.34 14.905 202.288 63.524 24.678 176.67 29.108 277.019 18.808C715.05 407.41 623.083 228.5 478.531 137.137c301.612 65.669 247.247 311.975 220.834 354.858l-557.052-2.033z"
                fill="#fea4a2"
                transform="matrix(.83468 0 0 .8351 61.21 -4.96)"
              />
            </g>
          </g>
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#ca6666"
            transform="matrix(.85633 .41821 -.43157 .88279 158.351 -184.534)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#ca6666"
            transform="matrix(.68813 -.65911 .68015 .70939 63.785 237.401)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#fc827e"
            transform="matrix(.92476 -.23055 .2379 .95333 -74.44 35.755)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#fc827e"
            transform="matrix(.68422 .66316 -.68433 .70536 232.604 -139.091)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#ca6666"
            transform="matrix(.9501 .07533 -.07773 .97946 64.566 -35.88)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#fc827e"
            transform="matrix(.7878 -.53615 .55327 .81214 74.382 248.848)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#ca6666"
            transform="matrix(.85633 .41821 -.43157 .88279 425.122 -95.123)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#ca6666"
            transform="matrix(.9463 -.11354 .11717 .97553 -108.63 71.74)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#ca6666"
            transform="matrix(.85633 .41821 -.43157 .88279 188.902 -30.06)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#fc827e"
            transform="matrix(.94394 .13168 -.13589 .9731 154.283 -134.9)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#fc827e"
            transform="matrix(.94581 -.1175 .12126 .97503 64.702 -20.263)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#ca6666"
            transform="matrix(.85633 .41821 -.43157 .88279 319.692 -179.744)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#fc827e"
            transform="matrix(.87128 -.38613 .39846 .8982 182.144 100.513)"
          />
          <ellipse
            cx={324.074}
            cy={231.087}
            rx={24.5}
            ry={5.5}
            fill="#ca6666"
            transform="matrix(.95299 -.0142 .01466 .98243 181.26 -10.744)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgFreeTimeCooking;
